import {renderElements, debounce} from "../utils/common";

const DeliveryPrice = {
  Москва: 430,
  "Санкт-Петербург": 300,
  Россия: 430,
  Мир: 2500,
};

export const changeAddress = () => {
  const changeAddressContainerElement = document.querySelector(`.js-change-adress-container`);

  let currentCity;

  if (changeAddressContainerElement) {
    const formElement = changeAddressContainerElement.closest(`form`);
    const addressInputElement =
      changeAddressContainerElement.querySelector(`.js-change-adress-element`);
    const suggestionListElement =
      changeAddressContainerElement.querySelector(`.js-suggestion-list`);
    const deliveryPriceBoxElement = document.querySelector(".js-delivery-price-box");
    const deliveryPriceElement = document.querySelector(".js-delivery-price");
    const oldTotalPriceElement = document.querySelector(".js-basic-total-price");
    const oldTotalPrice = +oldTotalPriceElement.dataset.price;

    const radioName = document.querySelector(`.js-change-adress-radio`).name;
    const DELIVERY_NAME = `OrderForm[delivery_type]`;
    const DELIVERY_PRICE_NAME = `OrderForm[delivery_price_curier]`;

    const getItemTemplateElement = ({value}) => {
      return `<li class="order__suggestion-item js-suggestion-item" tabindex="0">${value}</li>`;
    };

    const fetchAddressFromDadata = (evt) => {
      if (currentCity === `Мир`) {
        return;
      }
      const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
      const token = "b31f085e33d15c0969e770f052866a9a304a7044";

      let locations = {};

      switch (currentCity) {
        case `Санкт-Петербург`:
          locations = [
            {
              region: currentCity,
            },
            {
              region: `Ленинградская`,
            },
          ];
          break;
        case `Москва`:
          locations = [
            {
              region: currentCity,
            },
            {
              region: `Московская`,
            },
          ];
          break;
        case `Россия`:
          locations = {
            country: currentCity,
          };
          break;
      }

      const options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Token " + token,
        },
        body: JSON.stringify({
          query: evt.target.value,
          locations,
          from_bound: {value: "city"},
        }),
      };

      return fetch(url, options)
        .then((response) => response.json())
        .then((data) => renderSuggestionLocations(data))
        .catch((error) => console.log("error", error));
    };

    const renderSuggestionLocations = (data) => {
      if (suggestionListElement.children.length) {
        Array.from(suggestionListElement.children).forEach((element) => element.remove());
      }
      renderElements(suggestionListElement, data.suggestions, getItemTemplateElement);

      if (suggestionListElement.children.length) {
        suggestionListElement.classList.add(`active`);
      }
    };

    const clearData = () => {
      deliveryPriceBoxElement.style.display = `none`;
      deliveryPriceElement.textContent = ``;
      oldTotalPriceElement.textContent = oldTotalPrice.toLocaleString();
      formElement[DELIVERY_PRICE_NAME].value = ``;
    };

    const onSearchInput = debounce((evt) => fetchAddressFromDadata(evt), 500);

    formElement.addEventListener(`change`, (evt) => {
      if (evt.target.classList.contains(`js-change-adress-radio`)) {
        if (currentCity !== formElement[radioName].value) {
          if (suggestionListElement.children.length) {
            Array.from(suggestionListElement.children).forEach((element) => element.remove());
          }
          currentCity = formElement[radioName].value;
          oldTotalPriceElement.textContent = (
            oldTotalPrice + DeliveryPrice[formElement[radioName].value]
          ).toLocaleString();
          deliveryPriceBoxElement.style.display = `grid`;
          deliveryPriceElement.textContent =
            DeliveryPrice[formElement[radioName].value].toLocaleString();
          formElement[DELIVERY_PRICE_NAME].value = DeliveryPrice[formElement[radioName].value];
        }
        addressInputElement.removeAttribute(`disabled`);
      } else if (evt.target.classList.contains(`js-delivery-radio`)) {
        if (formElement[DELIVERY_NAME].value === "2") {
          // clearData();
          return;
        } else {
          if (currentCity) {
            if (suggestionListElement.children.length) {
              Array.from(suggestionListElement.children).forEach((element) => element.remove());
            }
            oldTotalPriceElement.textContent = (
              oldTotalPrice + DeliveryPrice[formElement[radioName].value]
            ).toLocaleString();
            deliveryPriceBoxElement.style.display = `grid`;
            deliveryPriceElement.textContent =
              DeliveryPrice[formElement[radioName].value].toLocaleString();
            formElement[DELIVERY_PRICE_NAME].value = DeliveryPrice[formElement[radioName].value];
          }
        }
      }
    });

    addressInputElement.addEventListener(`input`, onSearchInput);

    addressInputElement.addEventListener(`blur`, () =>
      suggestionListElement.classList.remove(`active`),
    );

    suggestionListElement.addEventListener(`click`, (evt) => {
      if (evt.target.classList.contains(`js-suggestion-item`)) {
        addressInputElement.value = evt.target.textContent;
        suggestionListElement.classList.remove(`active`);
      }
    });
  }
};
